var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        placeholder: _vm.placeholder,
        multiple: _vm.multiple,
        disabled: _vm.disabled,
        "value-key": _vm.valueKey,
        size: _vm.size,
        clearable: _vm.clearable,
      },
      on: { change: _vm.onChange },
      model: {
        value: _vm.id,
        callback: function ($$v) {
          _vm.id = $$v
        },
        expression: "id",
      },
    },
    _vm._l(_vm.list, function (item, index) {
      return _c("el-option", {
        key: index,
        attrs: {
          label: item.name,
          value: item.areaCode,
          disabled: item.disabled,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }